import AntdBadge     from 'antd/lib/badge';
import React         from 'react';
import { ReactNode } from 'react';
import useTheme      from '@widesk-ui/hooks/useTheme';

export type BadgeProps = {
	color: string;
	text: React.ReactNode;
}

export type BadgeCountProps = {
	count?: number;
	children: ReactNode;
}

const Badge = (props: BadgeProps) => {
	const theme = useTheme();

	return (
		<AntdBadge
			color={props.color}
			text={props.text}
			style={{ whiteSpace: 'nowrap' }}
			styles={{
				indicator: {
					border: `1px solid ${theme.colorBgContainer}`,
					width: 10,
					height: 10,
				},
			}}
		/>
	);
};

Badge.Count = (props: BadgeCountProps) => {
	return (
		<AntdBadge
			{...props}
		/>
	);
};

export default Badge;
